export const FORM_LOADER = 'FORM_LOADER'